import { CustomerState, InventoryState } from 'src/types/redux';
import {
  FETCH_INVENTORY_FAILURE,
  FETCH_INVENTORY_REQUEST,
  FETCH_INVENTORY_SUCCESS,
  InventoryActionType,
} from '../types/inventoryType';

const initialState: InventoryState = {
  error: '',
  loading: false,
  inventoryData: [],
};

export const inventoryReducer = (
  state = initialState,
  action: InventoryActionType
): InventoryState => {
  switch (action?.type) {
    case FETCH_INVENTORY_REQUEST:
      return {
        ...state,
        loading: true,
        error: '',
      };
    case FETCH_INVENTORY_SUCCESS:
      return {
        ...state,
        loading: false,
        inventoryData: action?.payload,
      };
    case FETCH_INVENTORY_FAILURE:
      return {
        ...state,
        loading: false,
        error: action?.payload,
      };
    default:
      return state;
  }
};
